export const buildVPNStatusData = vpnData => ({
    connected: vpnData.conn === 'ok',
    ip: vpnData.tun_address
});
